package example.shadcn_kotlin.ui.pages.docs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.docs.figma.Figma

@Page
@Composable
fun FigmaPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/figma.md", mapOf("title" to listOf("Figma"), "description" to listOf("Every component recreated in Figma. With customizable props, typography and icons.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("The Figma UI Kit is open sourced by ")
                org.jetbrains.compose.web.dom.A("https://twitter.com/skirano", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("Pietro Schirano")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            Figma()
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("grab-a-copy")
 }) {
                org.jetbrains.compose.web.dom.Text("Grab a copy")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.A("https://www.figma.com/community/file/1203061493325953101", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("https://www.figma.com/community/file/1203061493325953101")
                }
            }
        }
    }
}
